import {placeFact} from "../../../../constants/Content/placeFact.constants";

const initialState = {
    fetching : false,
    status : false,
    placeFacts : {},
    error : {}

};

export default function (state = initialState, action) {
    switch (action.type) {
        case placeFact.PLACE_FACT_LIST_PENDING:
            return {
                ...state,
                fetching: true,
                status: false,
                placeFacts:{}
            };
        case placeFact.PLACE_FACT_LIST_FULFILLED:
            return {
                ...state,
                fetching: false,
                status: true,
                placeFacts: action.payload
            };
        case placeFact.PLACE_FACT_LIST_REJECTED:
            return {
                ...state,
                error: action.payload,
                fetching: false,
                status: false
            };
        default:
            return state
    }
}
